import moment from "moment";

export interface Tab {
  id: number;
  active: boolean;
  icon?: React.ReactNode;
  title: string;
  tabsDisabled?: boolean;
  value?: string;
}

export const getActiveTabId = (tabs: Tab[]): number | undefined => {
  return tabs?.find((t) => t.active)?.id;
};

export const handleChangeTab = (tabs: Tab[], clicked: number): Tab[] => {
  return tabs?.map((p) => {
    return p.id === clicked
      ? {
        ...p,
        active: true,
        tabsDisabled: false,
      }
      : {
        ...p,
        active: false,
      };
  });
};

export const formatColumnLabel = ($label: string) => {
  return $label
    .replace('field:', '')
    // Convert snake_case or SCREAMING_SNAKE_CASE to spaces
    .replace(/_/g, ' ')
    // Insert space before capital letters (for camelCase / PascalCase)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatLabel = (key: string) => {
  return key
    ?.replace(/^[^.]+\./, "") // remove everything before the first dot (including the dot)
    ?.replace(/_/g, " ")      // replace underscores with spaces
    ?.replace(/\b\w/g, (l) => l?.toUpperCase()); // capitalize each word
};
// export const formatDateDefault = (val: any) => {
//   const date = new Date(val);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };
export const isValidDateInput = (val: any): boolean => {
  if (val instanceof Date) {
    return !isNaN(val.getTime());
  }

  if (typeof val === "string") {
    const trimmed = val.trim();
    if (!trimmed) return false;

    // Ignore purely numeric strings so "123" isn't coerced into year 123-01-01.
    if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return false;
    }

    // Only treat strings that look like dates as valid date inputs.
    if (!/[\-/]/.test(trimmed) && !trimmed.toUpperCase().includes("T")) {
      return false;
    }

    const d = new Date(trimmed);
    return !isNaN(d.getTime());
  }

  return false;
};
export const formatDateForApi = (val: any): string => {
  const d = new Date(val);
  if (isNaN(d.getTime())) return String(val);

  const pad = (n: number) => String(n).padStart(2, "0");

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());

  return `${year}-${month}-${day}T00:00:00.000`;
};


export const formatText = (text: string) => {
  return text
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());



};

export const TextWithoutDashes = (text: string) => text
  .toLowerCase()
  .replace(/-/g, " ")
  .replace(/\b\w/g, char => char.toUpperCase());

export const formattedText = (text: string) => {
  return text
    .replace(/_/g, ' ')                 // remove underscores
    .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
};
export const formatLabelWithUnderscore = (input: string) => {
  return input
    .replace(/\s+/g, '')             // Remove all spaces
    .replace(/_/g, ' ')              // Replace underscores with space
    .toLowerCase()                   // Make it lowercase
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
}

// Extract unique fields for Contacts and Organizations Multiple API respose and Validations functions start

type SubmissionValue = {
  field: { id: number; name: string };
  value: string | number;
};
export function extractUniqueFields(items: any[]): {
  submissionFields: { id: number; name: string }[];
  crmFieldValues: { id: number; name: string }[];
} {
  const submissionFieldMap = new Map<number, { id: number; name: string }>();
  const crmFieldMap = new Map<number, { id: number; name: string }>();

  items?.forEach((item) => {
    const submissionValues: SubmissionValue[] =
      item?.cfr?.formSubmissions?.submissionValues || [];

    submissionValues?.forEach((entry) => {
      const fieldId = entry.field?.id;
      const fieldName = entry.field?.name;

      if (fieldId && fieldName && !submissionFieldMap.has(fieldId)) {
        submissionFieldMap.set(fieldId, { id: fieldId, name: fieldName });
      }
    });

    const crmFieldValues = item?.cfr?.crmFieldValues || [];

    crmFieldValues?.forEach((field: { field?: { id: number; name: string } }) => {
      const fieldId = field.field?.id;
      const fieldName = field.field?.name;

      if (fieldId && fieldName && !crmFieldMap.has(fieldId)) {
        crmFieldMap.set(fieldId, { id: fieldId, name: fieldName });
      }
    });
  });

  return {
    submissionFields: Array.from(submissionFieldMap.values()),
    crmFieldValues: Array.from(crmFieldMap.values()),
  };
}

export function isFieldRequired(field: string, records: any[]): boolean {
  const allEmpty = records?.every((rec) => {
    const value = rec[field];
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    );
  });

  return !allEmpty;
}

function hasValue(val: unknown): boolean {
  if (val === null || val === undefined) return false;

  if (typeof val === "string") return val.trim().length > 0;

  if (typeof val === "number") return !isNaN(val);

  if (Array.isArray(val)) return val.length > 0;

  return true;
}

export function isFieldRequiredFromRecords(records: any[], fieldId: number | string): boolean {
  if (!Array.isArray(records)) return false;

  return records.some((record) => {
    const submissionValues = record?.cfr?.formSubmissions?.submissionValues ?? [];
    const crmFieldValues = record?.cfr?.crmFieldValues ?? [];
    const allValues = [...submissionValues, ...crmFieldValues];

    return allValues.some((item) => item?.field?.id === fieldId && hasValue(item?.value));
  });
}

// Extract unique fields for Contacts and Organizations Multiple API respose and Validations functions start

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(2)} ${sizes[i]}`;
}


export const getInitial = (name?: string) => {
  if (!name) return "?";

  // Remove extra spaces
  const trimmed = name.trim();

  // Extract first alphabetic character
  const match = trimmed.match(/[A-Za-z]/);

  return match ? match[0].toUpperCase() : "?";
};

export function capitalizeFirstLetter(str: string): string {
  if (typeof str !== 'string' || str.length === 0) return '';
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}


// export const formatDateDefault = (date: Date | null): string => moment(date).format("MM-DD-YYYY");
export const formatDateDefault = (date: Date | null, withTime: boolean = false): string => {
  if (!date) return "";

  const baseFormat = "MM-DD-YYYY";
  if (withTime) {
    return moment(date).format(`${baseFormat} h:mm A`);
  }
  return moment(date).format(baseFormat);
};

export const formatTimezone = (timestamp: Date | null) => {
  if (!timestamp) return "-";

  const date = new Date(timestamp);

  // 1️⃣ Calculate UTC offset in hours
  const offsetMinutes = -date.getTimezoneOffset(); // Invert: JS returns local→UTC
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const gmtOffset = `GMT ${sign}${hours}`;

  // 2️⃣ Get long timezone name (e.g., "Eastern Standard Time")
  const longFormatter = new Intl.DateTimeFormat("en-US", {
    timeZoneName: "long",
  });
  const longParts = longFormatter.formatToParts(date);
  const timeZoneLong = longParts.find((p) => p.type === "timeZoneName")?.value || "";

  // 3️⃣ Get short timezone abbreviation (e.g., "EST")
  const shortFormatter = new Intl.DateTimeFormat("en-US", {
    timeZoneName: "short",
  });
  const shortParts = shortFormatter.formatToParts(date);
  const timeZoneShort = shortParts.find((p) => p.type === "timeZoneName")?.value || "";

  return `${gmtOffset} (${timeZoneLong}, ${timeZoneShort})`;
};

export const copyToClipboard = async (text: string | number) => {
  try {
    await navigator.clipboard.writeText(String(text)); // ✅ convert to string
  } catch (err) {
    console.error("Failed to copy!", err);
  }
};


const colors = ['#003366', '#FF6D41'];

export const getRandomColor = (index: number) => {
  // return colors[Math.floor(Math.random() * colors.length)];
  return index % 2 === 0 ? colors[0] : colors[1];
};


export function hexToRgba(hex: string, alpha: number) {
  const r = parseInt(hex?.slice(1, 3), 16);
  const g = parseInt(hex?.slice(3, 5), 16);
  const b = parseInt(hex?.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// export const getPercentage = (total: number, processed: number): number => {
//   if (total <= 0) return 0;
//   if (processed <= 0) return 0;
//   return (processed / total) * 100;
// };

export const getPercentage = (total?: number | null, processed?: number | null): number => {
  const t = Number.isFinite(total) ? total! : 0;
  const p = Number.isFinite(processed) ? processed! : 0;
  if (t <= 0) return 0;

  const percent = (p / t) * 100;
  const rounded = Math.floor(percent);

  return Math.min(100, Math.max(0, rounded));
}

export const formatFieldValue = (value: any, dataType?: string): string => {
  // Handle null/undefined
  if (value == null || value === '') {
    return '';
  }

  // Handle DATE_TIME
  if (dataType === 'DATE_TIME') {
    // Replace with your actual date formatter
    // Example using built-in Intl or your custom formatDateDefault
    return formatDateDefault(value);
  }

  // Handle Multiple Choice types (case-sensitive as per your system)
  if (dataType === 'MULTIPLE_CHOICES' || dataType === 'Multiple_Choice') {
    // If it's already a plain string like "Vendor,Partner"
    if (typeof value === 'string') {
      // Check if it looks like a JSON array: starts with [ and ends with ]
      const trimmed = value.trim();
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.join(',');
          }
        } catch (e) {
          // If JSON parsing fails, return the original string
          return trimmed;
        }
      }
      // Return as-is (e.g., "Vendor,Partner")
      return trimmed;
    }

    // If it's already an array (e.g., from form state)
    if (Array.isArray(value)) {
      return value.join(',');
    }

    // Fallback: convert to string
    return String(value);
  }

  // Default: return string representation
  return String(value);
};